import { css, cx } from 'emotion';

import {
	grey,
	lightGrey,
	darkGrey,
	museo900,
	textBlock,
	headingSmall,
	quadrantsStyle,
	mobileMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	contentSection,
} from 'inside-out/global-styles';

export const quadrantsWrapper = quadrantsStyle;

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
	overflowX: 'hidden',
});

export const sectionsStyle = css({
	borderBottom: `1px solid ${lightGrey}`,
});

export const sectionStyle = background => contentSection(background, '30px');

export const introStyle = css({
	display: 'table',
	margin: '60px auto',
	padding: '0 20px',
	width: '100%',
	maxWidth: desktopMaxWidthBreakpoint,
	'& > div': {
		display: 'table-cell',

		verticalAlign: 'top',
		'&:first-child': {
			width: '60%',
		},
	},
	'& h1': {
		...museo900,
		color: darkGrey,
		fontSize: '36px',
		lineHeight: '36px',
		marginTop: '0',
		marginBottom: '11px',
		fontWeight: 'normal',
	},
	'& p': cx(
		textBlock,
		css({
			width: '400px',
		})
	),
	'& h2': {
		color: grey,
		fontSize: '10px',
		lineHeight: '12px',
		letterSpacing: '0.5px',
		fontWeight: 'bold',
		textTransform: 'uppercase',
		marginTop: '0',
		marginBottom: '6px',
	},
	'& span': cx(
		headingSmall,
		css({
			display: 'block',
			lineHeight: '18px',
		})
	),
});

export const rightStyle = css({
	'& div:first-child': {
		marginBottom: '39px',
	},
});



// WEBPACK FOOTER //
// ./src/page-styles/policy-and-service-development/section/index.js